import React from 'react';
import { Button, Spinner } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import { useRefineSearchFormContext } from './useRefineSearchForm';

interface RefineSearchHeaderProps {
    onCancel: () => void;
}

const RefineSearchHeader = ({ onCancel }: RefineSearchHeaderProps) => {
    const { data } = useIdentifiedListContext();
    const form = useRefineSearchFormContext();

    return (
        <div className="flex items-center justify-between">
            <div className="text-foreground">
                <span className="text-xl font-bold">{`${UIStrings.RefineSearch} `}</span>
                <span className="text-xl font-normal">
                    ({UIStrings.NumberOfCandidatesIdentified(data?.pagination.totalCount || 0)})
                </span>
            </div>
            <div className="flex items-center gap-2.5">
                <Button variant="ghost" size="lg" onClick={onCancel}>
                    {UIStrings.Cancel}
                </Button>
                <Button
                    variant="default"
                    size="lg"
                    type="submit"
                    disabled={!form.formState.isDirty || form.formState.isSubmitting}
                >
                    {form.formState.isSubmitting && <Spinner className="mr-2 h-4 w-4" />}
                    {UIStrings.ApplyChanges}
                </Button>
            </div>
        </div>
    );
};

export default RefineSearchHeader;
